import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import TextButton from 'LuxKit/Button/TextButton'
import { staticPageMessages } from 'constants/config/i18nMessages'
import Group from 'components/utils/Group'

import MerchandiseBrandsCarousel from '../MerchandiseCarousels/MerchandiseBrandsCarousel'
import MerchandiseCategoriesCarousel from '../MerchandiseCarousels/MerchandiseCategoriesCarousel'
import MerchandiseLandingPageHero from './MerchandiseLandingPageHero'
import MerchandiseOfferCarousel from '../MerchandiseCarousels/MerchandiseOfferCarousel'
import MerchandiseBestOfBrandCarousel from '../MerchandiseCarousels/MerchandiseBestOfBrandCarousel'
import MerchandiseBestOfCategoryCarousel from '../MerchandiseCarousels/MerchandiseBestOfCategoryCarousel'
import MerchandisePointsCarousel from '../MerchandiseCarousels/MerchandisePointsCarousel'
import MerchandiseRecentlyViewedCarousel from '../MerchandiseCarousels/MerchandiseRecentlyViewedCarousel'

const popularProductsFilters: App.MerchandiseFilters = {
  sortBy: 'recommended',
}

const topBrandsFilter: App.MerchandiseBrandFilters = {
  sortBy: 'top',
  limit: 20,
}

const topCategoriesFilter: App.MerchandiseCategoryFilters = {
  sortBy: 'top',
  level: 0,
  limit: 6,
}

/**
 * Temporary hardcoded carousels for the launch.
 * Will be replaced with a dynamic implementation in the future.
 */
const HOME_GARDEN_CATEGORY_ID = '7ef43fcc-9eb7-59c4-a091-1549d672f754'
const ELECTRONICS_CATEGORY_ID = 'a10eb183-c659-5256-8f4f-d150448c98e9'

const APPLE_CAROUSEL = 'Apple'
const SAMSONITE_CAROUSEL = 'Samsonite'
const SMEG_CAROUSEL = 'Smeg'

const ShopLandingPageLinks = styled(Group)`
  margin: ${rem(32)} 0 ${rem(48)};
`

function MerchandiseLandingPage() {
  const trackingPageName = 'Landing Page'

  return <div>
    <MerchandiseLandingPageHero />
    <MerchandisePointsCarousel trackingPageName={trackingPageName} />
    <MerchandiseCategoriesCarousel
      title={
        <FormattedMessage
          id="5XJrs0wx-C_KYdcn_IJ-"
          defaultMessage="Shop our <em>categories</em>"
          description="Title for categories carousel on merchandise landing page"
          values={{
            em: (chunks) => <em>{chunks}</em>,
          }}
        />
      }
      viewAllTo="/shop/categories"
      filters={topCategoriesFilter}
    />
    <MerchandiseOfferCarousel
      title={
        <FormattedMessage
          id="cKrckj-_rp33dAX5mx3m"
          defaultMessage="Top products <em>for you</em>"
          description="Title for personalized top products carousel on merchandise landing page"
          values={{
            em: (chunks) => <em>{chunks}</em>,
          }}
        />
      }
      filters={popularProductsFilters}
      viewAllTo="/search/shop"
      trackingListName="Top products for you"
      trackingPageName={trackingPageName}
    />
    <MerchandiseBrandsCarousel
      title={
        <FormattedMessage
          id="JNBDA574Elo0LRAvA2v-"
          defaultMessage="Our top <em>brands</em>"
          description="Title for top brands carousel on merchandise landing page"
          values={{
            em: (chunks) => <em>{chunks}</em>,
          }}
        />
      }
      filters={topBrandsFilter}
      viewAllTo="/shop/brands"
    />
    <MerchandiseRecentlyViewedCarousel
      trackingPageName={trackingPageName}
    />
    <MerchandiseBestOfBrandCarousel
      trackingPageName={trackingPageName}
      brandName={APPLE_CAROUSEL}
    />
    <MerchandiseBestOfCategoryCarousel
      trackingPageName={trackingPageName}
      categoryId={HOME_GARDEN_CATEGORY_ID}
    />
    <MerchandiseBestOfBrandCarousel
      trackingPageName={trackingPageName}
      brandName={SAMSONITE_CAROUSEL}
    />
    <MerchandiseBestOfCategoryCarousel
      trackingPageName={trackingPageName}
      categoryId={ELECTRONICS_CATEGORY_ID}
    />
    <MerchandiseBestOfBrandCarousel
      trackingPageName={trackingPageName}
      brandName={SMEG_CAROUSEL}
    />
    <ShopLandingPageLinks direction="horizontal" horizontalAlign="center" verticalAlign="center" gap={16}>
      <TextButton kind="secondary" to="/shop-faqs">
        <FormattedMessage {...staticPageMessages.shopFAQs} />
      </TextButton>
      <TextButton kind="secondary" to="/shop-terms-and-conditions">
        <FormattedMessage {...staticPageMessages.shopTermsAndConditions} />
      </TextButton>
    </ShopLandingPageLinks>
  </div>
}

export default MerchandiseLandingPage
